import { VxeUI } from 'vxe-pc-ui';

export const custom = (msg, icon) => {
    return VxeUI.modal.message({
        content: msg,
        iconStatus: icon,
    });
};

export const info = (msg) => {
    return VxeUI.modal.message({
        content: msg,
        status: 'info',
    });
};

export const warning = (msg) => {
    return VxeUI.modal.message({
        content: msg,
        status: 'warning',
    });
};

export const question = (msg) => {
    return VxeUI.modal.message({
        content: msg,
        status: 'question',
    });
};

export const success = (msg) => {
    return VxeUI.modal.message({
        content: msg,
        status: 'success',
    });
};

export const error = (msg) => {
    return VxeUI.modal.message({
        content: msg,
        status: 'error',
    });
};

export const loading = (msg) => {
    const msgId = 'ui-unique-loading';
    VxeUI.modal.message({
        id: msgId,
        content: msg,
        status: 'loading',
        duration: -1,
    });
    return () => {
        VxeUI.modal.close(msgId);
    };
};
